import {AbstractModel} from './abstract-model';
import {LandingPage} from './landing-page/landing-page';
import {Product} from './product';
import {Offer} from './offer';
import {Partner} from './partner/partner';
import {Site} from './site/site';

export class Click extends AbstractModel {
  id: number | null = null;
  createdAt: Date | null = null;
  ip: string | null = null;
  subid: string | null = null;
  tc1: string | null = null;
  tc2: string | null = null;
  tc3: string | null = null;
  tc4: string | null = null;
  clickid: string | null = null;
  gclid: string | null = null;
  gbraid: string | null = null;
  wbraid: string | null = null;
  fbclid: string | null = null;
  fbpxid: string | null = null;
  msclkid: string | null = null;
  mspxid: string | null = null;
  twclid: string | null = null;
  twpxid: string | null = null;
  ttclid: string | null = null;
  ttpxid: string | null = null;
  source: string | null = null;
  referer: string | null = null;
  site: Site | null = null;
  product: Product | null = null;
  landingPage: LandingPage | null = null;
  offer: Offer | null = null;
  partner: Partner | null = null;
  country: string | null = null;
  language: string | null = null;
  userAgent: string | null = null;
  bot: boolean = false;
  botAllowed: boolean = false;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.site) {
      this.site = new Site().deserialize(input.site);
    }

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    if (input.landingPage) {
      this.landingPage = new LandingPage().deserialize(input.landingPage);
    }

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    return this;
  }
}
